import { styled } from "@twilio-paste/core/styling-library";

export const MessageInfoContainer = styled("div")`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1.425em 0 0.083em;
    font-size: 12px;
    color: #606B85;
`;